export default {
  buttons: {
    skip: 'Overslaan',
    back: 'Terug',
  },
  toasts: {
    failed_to_load_data: 'Laden van gegevens mislukt',
    payment: {
      pending: 'Uw betaling wordt momenteel verwerkt...',
      success: '👍 Uw betaling is succesvol verwerkt. Bedankt!',
      error:
        '⁉️Er was een probleem met uw betaling of de verwerking duurt langer dan verwacht. Probeer de pagina 1 minuut te vernieuwen, neem anders contact op met de technische support.',
    },
  },
};
